import React from "react";
import ContactMe from "../../components/Contact/ContactMe";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Downloader from "../../components/Botones/Downloader";

function Contact() {
  return (
    <div>
      <Navbar />
      <Downloader />
      <ContactMe />
      <Downloader />
      <Footer />
    </div>
  );
}

export default Contact;
